
import { Component, Prop, Vue } from 'vue-property-decorator';

import { OrderSteps } from '../enums';

@Component
export default class OrderProgress extends Vue {
  @Prop({ default: false }) overrideReview: boolean;

  get orderSteps() {
    return Object.values(OrderSteps || {});
  }

  get stepInfo(): OrderStep {
    const routeName = this.$route?.name;
    return (this.orderSteps?.find(({ view, aliasViews = [] }) => {
      return view === routeName || aliasViews?.includes(routeName as string);
    })) || {} as OrderStep;
  }

  progressedToStep({ step }: { step: number }) {
    if (this.overrideReview) {
      return step <= OrderSteps.ORDER_SUMMARY.step;
    }
    return step <= this.stepInfo?.step;
  }

  stepIsComplete({ step }: { step: number }) {
    if (this.overrideReview) {
      return step < OrderSteps.ORDER_SUMMARY.step;
    }
    return step < this.stepInfo?.step;
  }
}
